import React from 'react';
import Axios from 'axios';
import moment from 'moment';

class NewsletterRegister extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			name: '',
			email: '',
			textmsg: '',
			leagues: '',
			inscriptionDate: '',
			approb: false
		};
	
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleApprob = this.handleApprob.bind(this);
	}

	render() {
		//console.log('NewsletterRegister: render')
		return (
			<div className="infolettre-box">
			<div className="infolettre-box-body">
			<form className="form-horizontal" onSubmit={this.handleSubmit}>
				
				<div className="form-group row">
					<label htmlFor="name" className="col-md-3 form-control-label text-left">Nom complet: </label>
					<div className="col-md-9">
					<input type="text" className="form-control" id="name" placeholder="prénom et nom" 
						value={this.state.name || ''} onChange={this.handleChange}/>
					</div>
				</div>

				<div className="form-group row">
					<label htmlFor="email" className="col-md-3 form-control-label text-left">Courriel: </label>
					<div className="col-md-9">
					<input type="email" className="form-control" id="email" placeholder="courriel" 
						value={this.state.email || ''} onChange={this.handleChange}/>
					</div>
				</div>

				<div className="form-group row">
					<label htmlFor="textmsg" className="col-md-3 form-control-label text-left">Messagerie texte: </label>
					<div className="col-md-9">
					<input type="textmsg" className="form-control" id="textmsg" placeholder="no messagerie texte" 
						value={this.state.textmsg || ''} onChange={this.handleChange}/>
					</div>
				</div>

				<div className="form-group row">
					<label htmlFor="leagues" className="col-md-3 form-control-label text-left">Ligues: </label>
					<div className="col-md-9">
					<input type="text" className="form-control" id="leagues" placeholder="ligues" 
						value={this.state.leagues || ''} onChange={this.handleChange}/>
					</div>
				</div>

				<div className="form-group row">
					<label htmlFor="approb" className="col-md-9 form-control-label text-left">
					J'autorise Statelo à me faire parvenir des informations<br/>(choisir "J'accepte" pour confirmer).
					</label>
					
					<div className="col-md-3">
					<select className="form-control" id="approb" value={this.state.approb} onChange={this.handleChange}>
						<option></option>
						<option>J'accepte</option>
					</select>
					</div>

				</div>

				<div className="form-group">
					<br/>
					<div className="col-xs-12 text-center">
					<button type="submit" className="btn btn-primary">M'inscrire à l'infolettre</button>
					</div>
				</div>

			</form>
			</div>
			</div>
		);
	}

	handleChange(e) {
		this.setState({[e.target.id]: e.target.value});
	}

	handleApprob(e) {
		this.setState({
			approb: e.target.checked
		});
	}

	handleSubmit(e) {
		e.preventDefault();

		// Validation
		if (this.state.approb !== "J\'accepte") {
			alert('Choisir \"J\'accepte\" pour confirmer votre inscription.');
		} else if (this.state.name === "") {
			alert('Entrer votre nom svp.');
		} else if (this.state.leagues === "") {
			alert('Entrer les ligues auxquelles vous participez.\nSi vous n\'en avez pas, inscrivez \'aucune\'.');
		} else {

			var todaysDate = new Date();
			var inscrDate = moment(todaysDate).utc().format("YYYY-MM-DD");

			var memberData = {
				name: this.state.name,
				email: this.state.email,
				leagues: this.state.leagues,
				textmsg: this.state.textmsg,
				inscriptionDate: inscrDate
			}

			Axios.post('/api/newsletterMembers/createModify', {
				memberId: null,
				memberData: memberData
			})
			.then(function(response) {
				console.log(response);
			})
			.catch(function(error) {
				console.log(error);
			});
	
			// Inscription to the newsletters
			this.setState({
				name: '',
				email: '',
				leagues: '',
				textmsg: '',
				approb: ''
			})

			alert('Votre inscription a été complétée avec succès.');
		}
	}

}

export default NewsletterRegister;


